import * as ActionTypes from './constants';

export const setIsLoadingNextComponent = isLoading => {
  return {
    type: ActionTypes.IS_LOADING_NEXT,
    payload: isLoading
  };
};
